module.exports = __webpack_public_path__ + "static/media/Sabbir_01.2d7d5825.jpg";